import { Component, OnInit } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { AppComponent } from 'src/app/app.component';
import { AppMainComponent } from 'src/app/app.main.component';
import { CalendarDays, CreditCard, FileText, HandCoins, LayoutDashboard, List, Network, Newspaper, PersonStanding, Send, Settings, Tags, UserRound, UsersRound, X } from 'lucide-angular';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    standalone: false
})
export class AppMenuComponent implements OnInit {

  readonly X = X;

  public model: any[];

  isAuthenticated: boolean;

  constructor(public app: AppComponent, public appMain: AppMainComponent,
    private permissionsService: NgxPermissionsService) { }

  ngOnInit() {

    this.model = [
      {
        label: 'Dashboard', icon: LayoutDashboard, routerLink: ['/'],
        show: true
      }, {
        label: 'Eventos',
        icon: CalendarDays,
        routerLink: ['/events'],
        show: true
      }, {
        label: 'Circuitos',
        icon: Network,
        routerLink: ['/circuits'],
        show: true
      },
      {
        label: 'Inscritos',
        icon: Tags,
        routerLink: ['/enrollments'],
        show: true
      }, {
        label: 'Corredores',
        icon: PersonStanding,
        routerLink: ['/runners'],
        show: true
      },
      {
        label: 'Clubs',
        icon: UsersRound,
        routerLink: ['/clubs'],
        show: true
      },
      {
        label: 'Patrocinadores',
        icon: HandCoins,
        routerLink: ['/sponsors'],
        show: true
      }, {
        label: 'Categorias',
        icon: List,
        routerLink: ['/categories'],
        show: true
      }
      , {
        label: 'Configuraciones',
        icon: Settings,
        routerLink: ['/configurations'],
        show: true
      }, {
        label: 'Noticias',
        icon: Newspaper,
        routerLink: ['/news'],
        show: true
      }
      , {
        label: 'Envíos',
        icon: Send,
        routerLink: ['/mailings'],
        show: true
      }
      , {
        label: 'Documentos',
        icon: FileText,
        routerLink: ['/documents'],
        show: true
      }
      , {
        label: 'Dorsal 0',
        icon: CreditCard,
        routerLink: ['/bib0s'],
        show: true
      }
      , {
        label: 'Usuarios',
        icon: UserRound,
        routerLink: ['/users'],
        show: true
      }
    ];
  }
}
